
import { defineComponent, ref } from "vue";
import Logo from "@/components/LogoHimalia.vue";

export default defineComponent({
  name: "Header",
  components: { Logo },
  setup() {
    const mobileMenu = ref(false);
    return {
      mobileMenu,
      menuItems: [
        { link: "#sluzby", name: "Služby" },
        { link: "#products", name: "Produkty" },
        { link: "#tim", name: "Tím" },
        { link: "#kontakt", name: "Kontakt" },
      ],
    };
  },
});
